export var valuesInconsistencyType = ["PPNIdAndEmailDifferentAccounts", "UserWithPPNIdHasOtherEmail", "PPNIdMismatch", "PPNIdDoesNotExist", "OtherUsersWithEmail"];
/*

*/ 
//# sourceMappingURL=InconsistencyType.js.map